import { cx } from '../../cx'
import styles from './Spinner.module.css'

export interface SpinnerProps {
  /** Tekst dla czytnika ekranu; bez niego spinner jest czysto dekoracyjny. */
  label?: string
  className?: string
}

export function Spinner({ label, className }: SpinnerProps) {
  return (
    <span
      className={cx(styles.spinner, className)}
      role={label !== undefined ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
    />
  )
}
